module.exports = __webpack_public_path__ + "static/media/PBTC-BNB.378f4c81.svg";